<template>
    <item-page v-model="fields" v-bind="{ page, pageIndex }" v-intersect="setIndex" ref="page" @input="emit">
        <template v-for="(item, index) in fields">
            <item-node
                v-model="fields[index]"
                v-bind="{
                    mode,
                    size,
                }"
                v-on="{
                    pull,
                }"
                @input="emit"
                :key="index"
            />
        </template>
    </item-page>
</template>

<script>
import { mapGetters } from "vuex";

import ItemNode from "./item/item-node.vue";
import ItemPage from "./item/item-page.vue";

export default {
    components: {
        ItemPage,
        ItemNode,
    },
    props: {
        value: { type: Array, default: () => [] }, // form.fields

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        page: { type: [Object, File], default: () => ({}) },
        pageIndex: { type: Number, default: 0 },
    },
    data: () => ({
        fields: [],
        size: { width: null, height: null },
    }),
    computed: {
        ...mapGetters("employment/form/page", ["width"]),
    },
    mounted() {
        this.sync();
        this.setSize();
    },
    beforeDestroy() {
        this.size = { width: null, height: null };
        this.fields = [];
    },
    watch: {
        value() {
            this.sync();
        },
        pageIndex() {
            this.sync();
        },
        width() {
            this.setSize();
        },
    },
    methods: {
        sync() {
            this.fields = this.value.filter((item) => item.page == this.pageIndex);
        },
        emit() {
            let fields = this.value.filter((item) => item.page != this.pageIndex);
            this.$emit("input", fields.concat(this.fields));
        },
        pull(item) {
            let index = this.fields.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.fields.splice(index, 1);
            this.emit();
        },
        setSize() {
            let intervalId = setInterval(() => {
                let $el = this.$refs["page"]?.$el;
                if (!$el) return;

                let { width, height } = $el.getBoundingClientRect();
                if (!width || !height) return;
                this.size = { width, height };

                clearInterval(intervalId);
            }, 100);
        },
        setIndex(entries, observer, isIntersected) {
            if (!isIntersected) return;
            this.$emit("setIndex", this.pageIndex);
        },
    },
};
</script>

<style lang="scss" scope></style>
